export default __webpack_public_path__ + "static/media/harvests_thin.fb02b24f.svg";